<template>
  <div id="Gym">
    <Loader v-if="loading" />
    <div class="container">
      <h3 >Gym discount offers</h3>
      <p class="py-5">
        Everyone’s route to better health and fitness is different. With access
        to our latest gym offers, you're not tied down to one venue – there's
        even an online-only fitness option, giving you the flexibility to look
        after your health and wellbeing in the way that works for you.
      </p>
      <div class="contentGrid">
        <div id="swimImage" class="position-relative">
          <span class="position-absolute d-flex justify-content-center align-items-center" style="height: 50px; width: 140px; background-color: #00a200; top: 0; left: 0;">
            <img src="https://media.spectrum.life/assets/axa/nuffield_logo.svg" alt="nuffield logo" class="d-block" style="width: 80%"/>
          </span>
          <img
            src="https://media.spectrum.life/assets/axa/nuffield_swin.png"
            alt="man swimming"
          />
        </div>
        <div
          class="pb-3 d-flex flex-column justify-content-between"
          id="swinText"
        >
          <h4 class="mt-2">Dive into wellness at Nuffield Health</h4>
          <p class="mt-3">Nuffield Health’s fitness and wellbeing centres are a great place to develop healthy habits or try something new.</p>
          <b-button
            href="https://www.nuffieldhealth.com/axahealth/offer"
            target="_blank"
            variant="cta-outline"
            rel="noopner"
            class="align-self-end">
            <span class="mr-3">View</span>
            <i class="fa-solid fa-angle-right"></i>
          </b-button>
        </div>
        <div
          class="pb-3 d-flex flex-column justify-content-between"
          id="hussleText"
        >
          <h4 class="mt-2">Add flexibility to your routine with a Hussle multi-gym membership</h4>
          <p class="mt-3">Why choose between a gym near home and a gym near work when you could have both? With Hussle Monthly+ Pass, you’re not just a member of one gym. You can access multiple gyms from a range of over 2000.</p>
          <b-button
            :href="hussle_link"
            target="_blank"
            variant="cta-outline"
            rel="noopner"
            class="align-self-end">
            <span class="mr-3">View</span>
            <i class="fa-solid fa-angle-right"></i>
          </b-button>
        </div>
        <div id="husselImage" class="position-relative">
          <span class="position-absolute d-flex justify-content-center align-items-center" style="height: 50px; width: 140px; top: 0; left: 0; background: white">
            <svg viewBox="0 0 180 42" xmlns="http://www.w3.org/2000/svg" class="d-block" style="width: 95%">
              <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g transform="translate(-216.000000, -19.000000)">
                  <g transform="translate(216.000000, 19.000000)">
                    <path d="M102.447,24.5416313 C103.38018,26.094235 105.423429,27.2897419 107.091747,27.2897419 C108.731447,27.2897419 109.824512,26.4845115 109.824512,25.3051797 C109.824512,24.1542581 108.990249,23.3490276 106.976654,22.6584747 L105.250894,22.0546037 C101.9717,20.9038894 100.2167,19.0053871 100.2167,16.2151797 C100.2167,12.360318 103.150825,10.0879217 107.120571,10.0879217 C109.623152,10.0879217 111.915249,10.9783825 113.77041,13.1164009 L110.931055,15.8765392 C109.969465,14.6549032 108.558912,14.0000184 107.149189,14.0000184 C105.739673,14.0000184 104.416631,14.6043041 104.416631,15.8122535 C104.416631,17.0494424 105.423429,17.595871 107.580733,18.3724839 L109.220433,18.9765622 C112.212207,20.0696267 114.081677,21.968129 114.081677,25.0459631 C114.05306,28.6992581 111.14776,31.2020461 106.919212,31.2020461 C103.668636,31.2020461 100.882369,29.7379908 99.4152028,27.494212 L102.447,24.5416313 Z" fill="#2A2D36"></path><path d="M124.524643,24.6851129 C125.457823,26.2377166 127.644366,27.2899286 129.312892,27.2899286 C130.952592,27.2899286 132.045864,26.4844908 132.045864,25.305159 C132.045864,24.1542373 131.211394,23.3490069 129.198007,22.6584539 L127.471832,22.0545829 C124.192638,20.9038687 122.437846,19.0053664 122.437846,16.215159 C122.437846,12.3602972 125.37197,10.0879009 129.341717,10.0879009 C131.844297,10.0879009 134.136394,10.9783618 135.991555,13.1163802 L133.1522,15.8765184 C132.190611,14.6548825 130.780058,13.9999977 129.370541,13.9999977 C127.961025,13.9999977 126.637776,14.6042834 126.637776,15.8122327 C126.637776,17.0494217 127.644366,17.5958502 129.801878,18.3726705 L131.441578,18.9765415 C134.433353,20.069606 136.30303,21.9681083 136.30303,25.0459424 C136.274205,28.6992373 133.368906,31.2020253 129.140357,31.2020253 C125.889781,31.2020253 122.960012,29.8814724 121.493053,27.6376935 L124.524643,24.6851129 Z" fill="#2A2D36"></path><polygon fill="#2A2D36" points="46.8816843 10.433053 51.0527903 10.433053 51.0527903 18.5739055 59.912606 18.5739055 59.912606 10.433053 64.083712 10.433053 64.083712 30.8568318 59.912606 30.8568318 59.912606 22.5434447 51.0527903 22.5434447 51.0527903 30.8568318 46.8816843 30.8568318"></polygon><path d="M82.5242765,31.2019839 C77.6342074,31.2019839 74.2110968,27.8939654 74.2110968,22.8025369 L74.2110968,10.4331359 L78.3822028,10.4331359 L78.3822028,22.8597719 C78.3822028,25.5639194 80.0505207,27.1747949 82.5242765,27.1747949 C84.9982396,27.1747949 86.666765,25.5639194 86.666765,22.8597719 L86.666765,10.4331359 L90.8376636,10.4331359 L90.8376636,22.8025369 C90.8376636,27.8939654 87.3569032,31.2019839 82.5242765,31.2019839" fill="#2A2D36"></path><polygon fill="#2A2D36" points="145.439689 10.433053 149.610795 10.433053 149.610795 26.8870853 158.355518 26.8870853 158.355518 30.8568318 145.439689 30.8568318"></polygon><polygon fill="#2A2D36" points="167.101776 10.433053 179.816247 10.433053 179.816247 14.4027995 171.272882 14.4027995 171.272882 18.6027304 178.090279 18.6027304 178.004219 22.5720622 171.272882 22.5720622 171.272882 26.8870853 179.816247 26.8870853 179.816247 30.8568318 167.101776 30.8568318"></polygon><g transform="translate(0.000000, 0.022604)"><polygon fill="#B4FA05" points="27.5559677 41.0598871 21.3229493 37.5171221 21.3229493 25.8384816 6.10154378 41.0598871 0 37.5171221 11.8422581 11.7837581 9.19451613 13.753182 5.05182028 8.05829724 17.352788 0.184748848 23.4881336 3.66260599 14.7291014 22.278712 23.4906221 13.5064078 28.7369585 16.4562926 28.713318 29.4888733 32.2496544 26.0526982 36.6100922 32.0057627"></polygon>
                  </g>
                  </g>
                </g>
              </g>
            </svg>
          </span>
          <img
            src="https://media.spectrum.life/assets/axa/hussle.png"
            alt="man swimming"
          />
        </div>
        <div id="gymImage" class="position-relative">
          <span class="position-absolute d-flex justify-content-center align-items-center" style="height: 50px; width: 140px; background-color: #00a200; top: 0; left: 0;">
            <img src="https://media.spectrum.life/assets/axa/nuffield_logo.svg" alt="nuffield logo" class="d-block" style="width: 80%"/>
          </span>
          <img
            src="https://media.spectrum.life/assets/axa/nuffield.png"
            alt="man swimming"
          />
        </div>
        <div
          class="pb-3 d-flex flex-column justify-content-between"
          id="gymText"
        >
          <h4 class="mt-2">Never miss a workout with Nuffield Health’s 24/7 online gym membership.</h4>
          <p class="mt-3">Your Nuffield Health 24/7 membership gives you access to an online-only fitness service, so you can keep fit even when the gym’s not an option.</p>
          <b-button
            href="https://www.nuffieldhealth.com/axahealth/offer"
            target="_blank"
            variant="cta-outline"
            rel="noopner"
            class="align-self-end">
            <span class="mr-3">View</span>
            <i class="fa-solid fa-angle-right"></i>
          </b-button>
        </div>
      </div>
      <div class="my-5">
        <p style="font-weight: bold" >Explore our range of fitness videos, with something for everyone. Helping you to become, stronger, healthier and happier.</p>
        <div class="position-relative">
          <b-input
            class="filterSearchBar mx-auto brand-text"
            v-model="searchTerm"
            placeholder="Search..."
          />
          <i
            class="fa-solid fa-magnifying-glass position-absolute"
            style="bottom: 10px; right: 30px; font-size: 2.0rem"
            v-if="!searchTerm.length"
          ></i>
          <span
            @click="searchTerm = ''"
            class="position-absolute brand-highlight-1"
            style="cursor: pointer; top: 15px; right: 30px; font-size: 1.5rem; font-family: FilsonProBold, Arial, Helvetica, sans-serif; text-decoration: underline"
            v-else
          >Clear Search</span
          >
        </div>
        <div class="tagContainer mt-3">
          <b-button
            squared
            class="mr-4 my-2 btn"
            :variant="selectedFilter === 'Show all' ? 'cta' : 'cta-outline'"
            @click="clearFilter()"
            ><span>Show all</span></b-button
          >
          <b-button
            squared
            v-for="(tag, i) in tags"
            :key="'tag' + i"
            class="mr-4 my-2 btn"
            :variant="selectedFilter === tag ? 'cta' : 'cta-outline'"
            @click="selectFilter(tag)"
            ><span>{{ tag }}</span>
          </b-button>
          <div class="pt-5 carousel-container">
            <HomeCardContent
              :title="null"
              class="car"
              type="exercise"
              additionalTag="Videos"
              :mute="true"
              :exerciseTags="this.tags"
              :prevent-scroll="true"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import Loader from "@/components/Loader.vue";
import HomeCardContent from "@/components/Home/New/HomeCardContent.vue";
import EventBus from "@/helpers/eventbus";
import { debounce } from "@/helpers/debounce";

export default {
  name: "Gym",
  components: { Loader, HomeCardContent },
  data() {
    return {
      searchTerm: "",
      hussle_link: "",
      loading: true,
      selectedFilter: "Show all",
      debouncedSearchTerm: "",
      tags: ["Pilates", "Yoga", "Strength", "Cardio"]
    }
  },
  mounted() {
    this.getGymLink();
  },
  watch: {
    searchTerm: debounce(function(newQuery) {
      this.debouncedSearchTerm = newQuery;
    }, 500),
    debouncedSearchTerm: function(searchTerm) {
      EventBus.$emit("setSearch", searchTerm);
    }
  },
  methods: {
    clearFilter() {
      this.selectedFilter = "Show all";
      EventBus.$emit("setTag", null);
    },
    selectFilter(tag) {
      this.selectedFilter = tag;
      EventBus.$emit("setTag", tag);
    },
    async getGymLink() {
      const res = await this.api({ path: "api/u/sapphire/gym" });
      if(res.success) {
        this.hussle_link = res.hussle_link;
        this.loading = false;
      }
    }
  }
}

</script>
<style lang="less">
#Gym {
  h3 {
    font-size: 2.5em;
  }
  p {
    font-size: 1.6em;
  }
  .contentGrid {
    display: grid;
    margin: auto;
    grid-template-columns: 1fr 1fr;
    grid-row-gap: 32px;
    grid-column-gap: 16px;
    div {
      min-height: 250px;
      h4 {
        font-size: 2em;
      }
      img {
        width: 100%;
      }
      a {
        border-radius: 10px;
        width: 110px;
      }
    }
  }

  .filterSearchBar {
    all: unset;
    width: 98%;
    height: 40px;
    background-color: rgba(255, 255, 255, 1);
    border: 1px solid rgba(211, 211, 211, 1);
    border-radius: 6px;
    padding: 5px 20px;
    font-size: 1.5rem;
    box-sizing: border-box;
    font-family: FilsonProBold, Arial, Helvetica, sans-serif !important;
  }

  #pageNumber {
    display: none !important;
  }

  @media (min-width: 1200px) {
    .container {
      max-width: 960px !important;
    }
  }
  @media (max-width: 576px) {
    .contentGrid {
      grid-template-columns: 1fr;
      div {
        min-height: 150px;
      }
      #hussleText {
        grid-row: 4;
      }
    }
  }
}
</style>